module.exports = __webpack_public_path__ + "img/WW.fd00f254.png";